import { appendQualifierToStatisticsText } from "./statisticsText";

// ─── @deprecated ────────────────────────────────────────────────────────
// Series legacy usadas por StatisticsModulePage (4 sexos: Mujeres, Hombres, Intersexuales, Se ignora).
// Reemplazadas por SERIES_BY_SEX y demás constantes G1-G10 (2 sexos: Mujeres, Hombres).
// TODO: eliminar junto con StatisticsModulePage.jsx, useStatisticsData.js,
//       EstadisticasCI.jsx, EstadisticasCLB.jsx y statsModuleConfig.js.
// ────────────────────────────────────────────────────────────────────────
export const SERIES_BY_GENDER = [
  { name: "Mujeres", color: "#DE5E60", hoverColor: "#C94A4C" },
  { name: "Hombres", color: "#1C5866", hoverColor: "#154A56" },
  { name: "Intersexuales", color: "#FDC503", hoverColor: "#E0AF02" },
  { name: "Se ignora", color: "#7B8991", hoverColor: "#6A777E" },
];

export const SERIES_LOCATED_CONDITION = [
  { name: "Mujeres localizadas con vida", color: "#DE5E60", hoverColor: "#C94A4C" },
  { name: "Mujeres localizadas sin vida", color: "#EFB3B4", hoverColor: "#E09D9E" },
  { name: "Hombres localizados con vida", color: "#1C5866", hoverColor: "#154A56" },
  { name: "Hombres localizados sin vida", color: "#C0E4D9", hoverColor: "#A8D4C6" },
  { name: "Intersexual localizades con vida", color: "#FDC503", hoverColor: "#E0AF02" },
  { name: "Intersexual localizades sin vida", color: "#FDED22", hoverColor: "#E0D31E" },
  { name: "Se ignora localizades con vida", color: "#7B8991", hoverColor: "#6A777E" },
  { name: "Se ignora localizades sin vida", color: "#D1D7D9", hoverColor: "#B8C0C3" },
];

export const SERIES_LOCATED_CRIME = [
  { name: "Mujeres localizadas víctimas de delito", color: "#DE5E60", hoverColor: "#C94A4C" },
  { name: "Mujeres localizadas sin ser víctimas de delito", color: "#EFB3B4", hoverColor: "#E09D9E" },
  { name: "Hombres localizados víctimas de delito", color: "#1C5866", hoverColor: "#154A56" },
  { name: "Hombres localizados sin ser víctimas de delito", color: "#C0E4D9", hoverColor: "#A8D4C6" },
  { name: "Intersexuales localizades víctimas de delito", color: "#FDC503", hoverColor: "#E0AF02" },
  { name: "Intersexuales localizades sin ser víctimas de delito", color: "#FDED22", hoverColor: "#E0D31E" },
  { name: "Se ignora localizades víctimas de delito", color: "#7B8991", hoverColor: "#6A777E" },
  { name: "Se ignora localizades sin ser víctimas delito", color: "#D1D7D9", hoverColor: "#B8C0C3" },
];

export const SERIES_MISSING_CRIME = [
  { name: "Mujeres desaparecidas con violencia", color: "#DE5E60", hoverColor: "#C94A4C" },
  { name: "Mujeres desaparecidas sin violencia", color: "#EFB3B4", hoverColor: "#E09D9E" },
  { name: "Hombres desaparecidos con violencia", color: "#1C5866", hoverColor: "#154A56" },
  { name: "Hombres desaparecidos sin violencia", color: "#C0E4D9", hoverColor: "#A8D4C6" },
  { name: "Intersexual desaparecides con violencia", color: "#FDC503", hoverColor: "#E0AF02" },
  { name: "Intersexual desaparecides sin violencia", color: "#FDED22", hoverColor: "#E0D31E" },
  { name: "Se ignora desaparecides con violencia", color: "#7B8991", hoverColor: "#6A777E" },
  { name: "Se ignora desaparecides sin violencia", color: "#D1D7D9", hoverColor: "#B8C0C3" },
];

// G1, G2: Personas desaparecidas por sexo
export const SERIES_BY_SEX = [
  { name: "Mujeres", color: "#DE5E60", hoverColor: "#C94A4C" },
  { name: "Hombres", color: "#1C5866", hoverColor: "#134049" },
];

// G3: Desapariciones con/sin violencia por sexo
export const SERIES_VIOLENCE_BY_SEX = [
  { name: "Mujeres con violencia",  color: "#DE5E60", hoverColor: "#C94A4C" },
  { name: "Hombres con violencia",  color: "#1C5866", hoverColor: "#134049" },
  { name: "Mujeres sin violencia",  color: "#EFB3B4", hoverColor: "#E09A9B" },
  { name: "Hombres sin violencia",  color: "#C0E4D9", hoverColor: "#A3D4C5" },
];

// G4: Mujeres desaparecidas por rango de edad
export const SERIES_WOMEN_AGE_RANGE = [
  { name: "0-14",  color: "#F4D6D7", hoverColor: "#E8BCBD" },
  { name: "15-19", color: "#EFB3B4", hoverColor: "#E09A9B" },
  { name: "20-29", color: "#DE5E60", hoverColor: "#C94A4C" },
  { name: "30-39", color: "#C44A4C", hoverColor: "#A83A3C" },
  { name: "40-49", color: "#A33638", hoverColor: "#8B2E30" },
  { name: "50+",   color: "#7A2829", hoverColor: "#621F20" },
];

// G5: Hombres desaparecidos por rango de edad
export const SERIES_MEN_AGE_RANGE = [
  { name: "0-14",  color: "#C0E4D9", hoverColor: "#A3D4C5" },
  { name: "15-19", color: "#7BBFAD", hoverColor: "#63AD99" },
  { name: "20-29", color: "#1C5866", hoverColor: "#134049" },
  { name: "30-39", color: "#164855", hoverColor: "#0F3540" },
  { name: "40-49", color: "#103844", hoverColor: "#0A2A33" },
  { name: "50+",   color: "#0A2830", hoverColor: "#061C22" },
];

// G6: Personas localizadas por condición y delito (general)
export const SERIES_CONDITION_CRIME = [
  { name: "No víctimas de delito",                         color: "#7B8991", hoverColor: "#636F76" },
  { name: "Víctimas de delito diverso",                    color: "#FDC503", hoverColor: "#D4A602" },
  { name: "Víctimas de delito contemplado en Ley General", color: "#DE5E60", hoverColor: "#C94A4C" },
];

// G7, G8: Porcentaje de localización
export const SERIES_PERCENTAGE = [
  { name: "Porcentaje de localización", color: "#1C5866", hoverColor: "#134049" },
];

// G9: Mujeres localizadas por condición y delito
export const SERIES_WOMEN_CONDITION_CRIME = [
  { name: "No víctimas de delito",                         color: "#F4D6D7", hoverColor: "#E8BCBD" },
  { name: "Víctimas de delito diverso",                    color: "#EFB3B4", hoverColor: "#E09A9B" },
  { name: "Víctimas de delito contemplado en Ley General", color: "#DE5E60", hoverColor: "#C94A4C" },
];

// G10: Hombres localizados por condición y delito
export const SERIES_MEN_CONDITION_CRIME = [
  { name: "No víctimas de delito",                         color: "#C0E4D9", hoverColor: "#A3D4C5" },
  { name: "Víctimas de delito diverso",                    color: "#7BBFAD", hoverColor: "#63AD99" },
  { name: "Víctimas de delito contemplado en Ley General", color: "#1C5866", hoverColor: "#134049" },
];

// G11.1: Con carpeta de investigación
export const SERIES_INVESTIGATION_CI = [
  { name: "Con carpeta de investigación", color: "#1C5866", hoverColor: "#134049" },
];

// G11.2: Sólo con reporte ante COBUPEJ
export const SERIES_INVESTIGATION_REPORT = [
  { name: "Sin carpeta de investigación", color: "#DE5E60", hoverColor: "#C94A4C" },
];

/** @deprecated — Usado solo por StatisticsModulePage. Eliminar junto con el sistema legacy. */
export const qualifySeriesItems = (seriesItems = [], labelQualifier = null) =>
  seriesItems.map((item) => ({
    ...item,
    name: appendQualifierToStatisticsText(item.name, labelQualifier),
  }));
